<template lang="pug">
.graph-best-selling-product-group
  apexchart(width="100%" type="pie" :options="options" :series="series")
</template>

<script>
export default {
  computed: {
    options() {
      return {
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => `${opts.w.config.labels[opts.seriesIndex]} (${parseFloat(val).toFixed(1)}%)`,
          dropShadow: {
            enabled: true,
            top: 1,
            blur: 1,
            opacity: 0.25,
            color: '#FFFFFF',
          },
          style: {
            colors: ['#121212'],
          },
        },
        plotOptions: {
          pie: {
            customScale: 0.8,
            dataLabels: {
              offset: 60,
              minAngleToShowLabel: 15,
            },
          },
        },
        labels: this.labels,
        colors: ['#00429d', '#1d4da2', '#2c58a7', '#3963ac', '#446eb1', '#4f7ab5', '#5985ba', '#6391be', '#6e9dc1', '#78a9c5', '#83b5c8', '#90c1ca', '#9eccca', '#d1d1b3'], // eslint-disable-line
        legend: {
          show: false,
        },
      };
    },
    sortedData() {
      return [...this.groupsData].sort((x, y) => {
        if (x.value > y.value) return -1;
        if (x.value < y.value) return 1;
        return 0;
      });
    },
    processedData() {
      if (this.sort) return this.sortedData;
      return this.groupsData;
    },
    series() {
      return this.processedData.map(elm => elm.value);
    },
    labels() {
      return this.processedData.map(elm => `กลุ่ม ${elm.group}`);
    },
  },
  props: {
    groupsData: {
      type: Array,
      // default: () => ([
      //   { group: '01', value: 0.02 },
      //   { group: '02', value: 0.02 },
      //   { group: '03', value: 0.06 },
      //   { group: '04', value: 0.03 },
      //   { group: '05', value: 0.02 },
      //   { group: '06', value: 0.03 },
      //   { group: '07', value: 0.02 },
      //   { group: '08', value: 0.15 },
      //   { group: '09', value: 0.15 },
      //   { group: '10', value: 0.10 },
      //   { group: '11', value: 0.30 },
      //   { group: '12', value: 0.05 },
      //   { group: '13', value: 0.03 },
      //   { group: '99', value: 0.02 },
      // ]),
    },
    sort: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
// .graph-best-selling-product-group {}
</style>
